import { getClient } from 'utils/httpClient/httpClient.config';
import {
  getGuidsFromTokens,
  getServiceTokensFromGuids,
} from 'utils/serviceSelectionUtils';

const APPOINTMENT_PLAN_API_TIMEOUT = 5 * 1000; // 5 seconds

/**
 * Utility function to get ordered service GUIDs using the appointment plan API
 * Note: Only call this function when smart service ordering is needed (2+ services)
 */
export const getOrderedServiceGuids = async ({
  serviceGuids,
  users,
  apiUrlV3,
  businessToken,
}) => {
  try {
    const allServices = users.flatMap((user) => user.services);
    const serviceTokens = getServiceTokensFromGuids(allServices, serviceGuids);

    if (serviceTokens.length === 0) {
      return serviceGuids;
    }

    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => {
        reject(new Error('APPOINTMENT_PLAN_API_TIMEOUT'));
      }, APPOINTMENT_PLAN_API_TIMEOUT);
    });

    const fetchPromise = getClient().post(`${apiUrlV3}/appointments/plan`, {
      service_tokens: serviceTokens,
      business_token: businessToken,
    });

    const response = await Promise.race([fetchPromise, timeoutPromise]);
    const tokensOfOrderedServices = response.data.plan.map(
      (service) => service.service_token,
    );

    return getGuidsFromTokens(allServices, tokensOfOrderedServices);
  } catch (error) {
    if (
      error instanceof Error &&
      error.message === 'APPOINTMENT_PLAN_API_TIMEOUT'
    ) {
      // eslint-disable-next-line no-console
      console.warn('APPOINTMENT_PLAN_API_TIMEOUT', serviceGuids);
    }

    return serviceGuids;
  }
};
